export const REQUESTER_CONTENT_ADMIN_ROLE = 'Requester Content Admin'

export const canFilterByRequester = (currentUser: any): boolean =>
  currentUser?.result?.userType === 'SYSTEM' ||
  currentUser?.result?.role === REQUESTER_CONTENT_ADMIN_ROLE

export const hasActiveAppointmentFilter = (filterData: any): boolean => {
  if (!filterData) {
    return false
  }

  return Object.values(filterData).some((value) =>
    Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== ''
  )
}
